import React, { useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppSettings } from './../../config/app-settings.js';

function Logout() {
  const navigate = useNavigate();
  const context = useContext(AppSettings);

  useEffect(() => {
    // 通行証（トークン）をゴミ箱に捨てる
    localStorage.removeItem('access_token');
    // Context内のユーザー情報をリセット
    context.setUserInfo(null);
    // 必要なら他のユーザー情報も消す
    // localStorage.clear(); 
    // ログイン画面へ強制送還（replace: true で戻れないようにする）
    navigate('/login', { replace: true });

  }, [navigate, context]);

  // 処理中に一瞬だけ見えるメッセージ
  return (
    <div className="p-5 text-center">
      <h4>Logging out...</h4>
    </div>
  )
}

export default Logout;